// extracted by mini-css-extract-plugin
export default {"icons":"u9K78I8bFFT775xa2cGG","sizing":"JGofOPHWh2QQ00iJwD1Q","background":"sQwCs4mfQLfSoi06CRFw"};